export function upload(args) {  return { type: 'VIDEO/UPLOAD', args }  }
export function addFile(file) { return { type: 'FILES/SET', file }}
export function updateFile(file) { return { type: 'FILES/UPDATE', file }}
export function cancel(index) { return { type: 'FILES/UPLOAD/CANCEL', index }}
export function fetchVideos(idTeam) { return { type: 'TEAM/VIDEOS/FETCH', idTeam } }
export function addExternal(args) { return { type: 'EXTERNAL/HIGHLIGHT/UPLOAD', args }}
